import { useState, useEffect } from "react";
import {
  Box,
  Flex,
  SimpleGrid,
  Text,
  HStack,
  VStack,
  Button,
  Icon,
  Badge,
  Card,
  CardBody,
  Divider,
} from "@chakra-ui/react";
import { FiMapPin, FiGrid, FiChevronRight } from "react-icons/fi";
import Link from "../../../../components/Link";
import client from "../../../../helpers/Client";
import urlToId from "../../../../helpers/UrlToId";
import Pagination from "../../../../components/pagination/Pagination";

export default function ProjectListCardView({ Project }) {
  const initialItems = Array.isArray(Project) ? Project : (Project?.results || []);
  const [items, setItems] = useState(initialItems);
  const [currentPage, setCurrentPage] = useState(Array.isArray(Project) ? 1 : (Project?.current_page || 1));
  const [numOfPages, setNumOfPages] = useState(Array.isArray(Project) ? 1 : (Project?.num_of_pages || 1));
  const [pageSize, setPageSize] = useState(Array.isArray(Project) ? Project.length : (Project?.page_size || 20));
  const [totalItems, setTotalItems] = useState(Array.isArray(Project) ? Project.length : (Project?.num_of_items || initialItems.length));

  useEffect(() => {
    const nextItems = Array.isArray(Project) ? Project : (Project?.results || []);
    setItems(nextItems);
    setCurrentPage(Array.isArray(Project) ? 1 : (Project?.current_page || 1));
    setNumOfPages(Array.isArray(Project) ? 1 : (Project?.num_of_pages || 1));
    setPageSize(Array.isArray(Project) ? Project.length : (Project?.page_size || 20));
    setTotalItems(Array.isArray(Project) ? Project.length : (Project?.num_of_items || nextItems.length));
  }, [Project]);

  const fetchPage = async (page) => {
    if (page < 1 || page > numOfPages) return;
    const resp = await client.get("/projects/", { params: { page, page_size: pageSize } });
    const data = resp.data;
    setItems(data.results || []);
    setCurrentPage(data.current_page || page);
    setNumOfPages(data.num_of_pages || 1);
    setTotalItems(data.num_of_items || (data.results || []).length);
  };

  return (
    <Box p={4}>
      <VStack spacing={4} align="stretch">
        {items.map((project) => (
          <Link to={`/proje/${urlToId(project.url)}`} key={project.url}>
            <Card
              borderRadius="xl"
              boxShadow="sm"
              border="1px solid"
              borderColor="gray.400"
              
              _hover={{ shadow: "md", borderColor: "blue.200" }}
              transition="all 0.2s"
              bg="white"
            >
              <CardBody p={4}>
                <VStack align="start" spacing={3}>
                  <HStack justify="space-between" w="full">
                    <VStack align="start" spacing={0}>
                      <Text fontWeight="bold" fontSize="lg" color="gray.800">
                        {project.name}
                      </Text>
                      <Badge colorScheme="blue" variant="subtle" borderRadius="full" px={2} fontSize="xs">
                        {project.kind}
                      </Badge>
                    </VStack>
                    <Icon as={FiChevronRight} color="gray.400" />
                  </HStack>

                  <Divider />

                  <SimpleGrid columns={2} w="full" spacing={3}>
                    <HStack>
                      <Icon as={FiMapPin} color="gray.400" />
                      <VStack align="start" spacing={0}>
                        <Text fontSize="xs" color="gray.500">Konum</Text>
                        <Text fontSize="sm" fontWeight="medium">
                          {project.district_info?.name}, {project.city_info?.name}
                        </Text>
                      </VStack>
                    </HStack>

                    <HStack>
                      <Icon as={FiGrid} color="gray.400" />
                      <VStack align="start" spacing={0}>
                        <Text fontSize="xs" color="gray.500">Birim Sayısı</Text>
                        <Text fontSize="sm" fontWeight="medium">
                          {project.nof_units}
                        </Text>
                      </VStack>
                    </HStack>
                  </SimpleGrid>
                </VStack>
              </CardBody>
            </Card>
          </Link>
        ))}
      </VStack>

      {items.length === 0 && (
        <Box textAlign="center" py={10} color="gray.500">
          <Text>Proje bulunamadı.</Text>
        </Box>
      )}

      {numOfPages > 1 && (
        <Box mt={4}>
          <Pagination path={"proje"} num_of_items={totalItems} num_of_pages={numOfPages} currentPage={currentPage} />
        </Box>
      )}
    </Box>
  );
}
